<template>
  <div class="offLine">
    <div>
      <div class="offLine_content">
        <div class="offLine_shop">
          <img
            :src="
              orderParams.val
                ? orderParams.val.shop_pic
                : offLineShopList.shop_pic
            "
            alt=""
            style="width: 0.88rem; height: 0.88rem; margin-right: 0.15rem"
          />
          <p
            style="
              font-size: 0.14rem;
              font-weight: bold;
              color: #333333;
              line-height: 0.2rem;
              height: 0.2rem;
              width: 2.1rem;
            "
          >
            {{
              orderParams.val
                ? orderParams.val.shop_title
                : offLineShopList.shop_title
            }}
          </p>
        </div>
        <div class="information" @click="toShippingAddress()">
          <img
            src="../../assets/img/icon_address@2x.png"
            alt=""
            style="width: 0.09rem; height: 0.12rem"
          />
          <div class="peopleInformation">
            <p class="address">
              {{
                address.province
                  ? address.province + address.city + address.area + address.add
                  : "--"
              }}
            </p>
            <p class="phoneAndName">
              <span style="margin-right: 0.1rem">
                {{
                  address.phone ? address.phone + " " + address.name : "- -"
                }}</span
              >
              <span
                v-show="address.default==1"
                style="
                  width: 0.41rem;
                  height: 0.16rem;
                  background: #f0d8b1;
                  border-radius: 0.04rem;
                  display: block;
                  font-size: 0.11rem;
                  color: #93683d;
                  line-height: 0.16rem;
                  text-align: center;
                  margin-left: 0.1rem;
                "
                >默认</span
              >
            </p>
          </div>
          <img
            src="../../assets/img/btn_more@2x.png"
            alt=""
            style="width: 0.06rem; height: 0.09rem"
          />
        </div>
        <!-- 提货数量 -->
        <div class="pickUp">
          <van-cell-group>
            <van-field
              required
              v-model="pickUpNum"
              label="提货数量"
              placeholder="请填写提货数量"
            />
          </van-cell-group>
        </div>
      </div>
    </div>
    <div class="bottom">
      <van-button round type="info" class="MakeSureAdd" @click="toMakeSureAdd()"
        >确定</van-button
      >
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";
import { addressList, getRaising } from "../../api/home";
export default {
  data() {
    return {
      pickUpNum: "",
      offLineShopList: {},
      address: {},
      orderParams: {},
      addressId: "",
    };
  },
  created() {
    this.offLineShopList = this.$route.params.val;
    let backAddress = JSON.parse(sessionStorage.getItem("backAddress"));
    if (backAddress) {
      this.address = backAddress;
    } else {
      addressList({ default: 1 }).then((res) => {
        if (res.data.backdata.address.length > 0) {
          this.address = res.data.backdata.address[0];
        } else {
          this.$dialog
            .confirm({
              title: "请先设置地址",
              message: "您还没有设置默认地址，点击确定设置",
            })
            .then(() => {
              this.$router.push({ name: "收货地址" });
            })
            .catch(() => {
              this.$router.back();
            });
        }
      });
    }
    if (this.$route.params.val) {
      this.orderParams = this.$route.params;
      sessionStorage.setItem("orderParams", JSON.stringify(this.$route.params));
    } else {
      this.orderParams = JSON.parse(sessionStorage.getItem("orderParams"));
    }
  },
  methods: {
    toMakeSureAdd() {
      var isNum = /^[0-9]*$/;
      if (!isNum.test(this.pickUpNum)) {
        Toast("请输入纯数字");
      } else {
        if (this.pickUpNum <= 0) {
          Toast("至少提货一件");
        } else {
          // 请求提货接口  改
          getRaising({ num: this.pickUpNum, add_id: this.addressId })
            .then((res) => {
              Toast(res.data.msg);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
      console.log(this.pickUpNum);
    },
    toShippingAddress() {
      this.$router.replace({
        name: "收货地址",
      });
    },
  },
};
</script>

<style lang='scss'>
.offLine {
  padding: 0.49rem 0 0.22rem 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .offLine_content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .offLine_shop {
      width: 100%;
      height: 1.1rem;
      background: #ffffff;
      padding: 0.11rem 0.15rem;
      display: flex;
    }

    // 进货价格
    .offLine_price {
      width: 3.45rem;
      height: 0.89rem;
      margin-top: 0.11rem;
      background: #ffffff;
      border-radius: 0.08rem;

      .van-cell--required::before {
        margin-left: 0.13rem;
        left: 0.03rem;
        font-size: 0.14rem;
      }

      .van-field__control {
        font-size: 0.14rem;
      }

      .onePrice {
        .van-field__control {
          color: #93683d;
        }
      }

      .van-field__label {
        margin-left: 0.17rem;
        color: #333333;
        font-size: 0.14rem;
      }
    }
  }

  // 地址栏
  .information {
    margin-top: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 3.45rem;
    height: 0.9rem;
    padding: 0.12rem 0.15rem 0.15rem;
    margin-bottom: 0.11rem;
    background: url("../../assets/img/icon_adress_line@2x.png");
    background-position: bottom;
    background-size: contain;

    .peopleInformation {
      .address {
        width: 2.66rem;
        font-size: 0.14rem;
        font-weight: bold;
        color: #343434;
        line-height: 0.18rem;
        margin-bottom: 0.06rem;
      }

      .phoneAndName {
        font-size: 0.12rem;
        color: #343434;
        display: flex;
      }
    }
  }

  /* 提货数量 */
  .pickUp {
    width: 100%;
    padding: 0 0.15rem;
    .van-cell {
      padding: 0.1rem 0.16rem;
      font-size: 0.14rem;
      line-height: 0.24rem;
    }
    .van-cell--required::before {
      margin-left: 0.08rem;
      // left: 0.03rem;
      font-size: 0.14rem;
    }
    .van-cell__title {
      margin-left: 0.08rem;
    }
    .addShop_price {
      width: 100%;
      height: 0.89rem;
      margin-top: 0.11rem;
      background: #ffffff;
      border-radius: 0.08rem;

      .van-field__control {
        font-size: 0.14rem;
      }

      .onePrice {
        .van-field__control {
          color: #93683d;
        }
      }

      .van-field__label {
        margin-left: 0.17rem;
        color: #333333;
        font-size: 0.14rem;
      }
    }
  }

  .bottom {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    .MakeSureAdd {
      border: none;
      width: 2.72rem;
      height: 0.44rem;
      background: linear-gradient(0deg, #d1ae79 0%, #f0d8b1 100%);
      border-radius: 0.22rem;
      font-size: 0.16rem;
      font-weight: bold;
      color: #93683d;
    }
  }
}
</style>
